/** 通用浮动小条：fixed 定位，出现在给定矩形上方（空间不足则放下方） */

export type BarAction = string;

export function initBar(
  id: string,
  onAction: (action: BarAction) => void,
): {
  show(rect: DOMRect, disabled?: string[]): void;
  hide(): void;
  visible(): boolean;
} {
  const bar = document.getElementById(id)!;

  bar.addEventListener('mousedown', (e) => e.preventDefault()); // 防止点击抢走文本选区
  bar.addEventListener('click', (e) => {
    const target = (e.target as HTMLElement).closest('span[data-act]') as HTMLElement | null;
    if (!target || target.classList.contains('disabled')) return;
    onAction(target.dataset['act']!);
  });

  return {
    show(rect, disabled = []) {
      for (const span of bar.querySelectorAll<HTMLElement>('span[data-act]')) {
        span.classList.toggle('disabled', disabled.includes(span.dataset['act']!));
      }
      bar.hidden = false;
      const bw = bar.offsetWidth;
      const bh = bar.offsetHeight;
      let left = rect.left + rect.width / 2 - bw / 2;
      left = Math.max(8, Math.min(left, window.innerWidth - bw - 8));
      let top = rect.top - bh - 10;
      if (top < 8) top = rect.bottom + 10;
      bar.style.left = `${left}px`;
      bar.style.top = `${top}px`;
    },
    hide() {
      bar.hidden = true;
    },
    visible() {
      return !bar.hidden;
    },
  };
}
